import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const painPointsContent = {
  title: 'Si te identificás con esto, estás en el lugar correcto...',
  points: ['Pasás horas armando fichas de observación y registros evolutivos desde cero para cada niño.', 'Sentís que tus sesiones de estimulación temprana carecen de una estructura clínica clara.', 'Te cuesta encontrar material visual atractivo para trabajar áreas sensoriales, motoras y de lenguaje.', 'Las familias se van sin recursos claros para acompañar el proceso en casa.', 'Invertís más tiempo en buscar y diseñar material que en planificar tus intervenciones.']
};
export function PainPoints() {
  return <section className="py-24 px-4 bg-brand-dark relative" data-id="element-152">
      <div className="max-w-4xl mx-auto" data-id="element-153">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif text-center mb-16 text-brand-light" data-id="element-154">
          {painPointsContent.title}
        </motion.h2>

        <div className="space-y-4" data-id="element-155">
          {painPointsContent.points.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 rounded-2xl bg-brand-card border border-brand-cardBorder hover:border-red-900/30 transition-colors" data-id="element-156">
              <XCircle className="w-6 h-6 text-red-500/80 shrink-0 mt-0.5" data-id="element-157" />
              <p className="text-lg text-brand-light/90 font-sans" data-id="element-158">{point}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}